import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { FlexColumn, FlexRow } from "@similarweb/ui-components";

export const AntWebsiteTooltipTopCellWrapper = styled(FlexRow)`
    justify-content: space-between;
    width: 100%;
    gap: 4px;

    > div {
        display: flex;
        align-items: center;
        gap: 4px;
        overflow: hidden;
        padding: 0;
        flex: 1;
    }

    [class^="OpenQualificationSideBarLinkContainer"] {
        position: relative;
        top: initial;
        right: initial;
        margin: initial;
        height: auto;
        flex: 0 0 auto;
    }

    .swTable-linkOut {
        margin: initial;
        line-height: initial;
        height: auto;
        vertical-align: initial;

        &::before {
            margin: initial;
        }
    }

    .swTable-content-large {
        &.text {
            padding: 0;
        }
    }

    div.favicon {
        width: 24px;
        height: 24px;
        border-radius: 6px;
        padding: 4px;
        border: 1px solid ${colorsPalettes.carbon[50]};
        background-color: ${colorsPalettes.carbon[0]};
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
            max-height: 100%;
            max-width: 100%;
            border-radius: 6px;
            overflow: hidden;
            margin: 0;
            padding: 0;
        }
    }
`;

export const BacklinksDomainsTableContainer = styled(FlexColumn)`
    .ant-table {
        .ant-table-body {
            table {
                tbody {
                    tr {
                        td.ant-table-cell-row-hover {
                            ${AntWebsiteTooltipTopCellWrapper} {
                                .swTable-linkOut {
                                    opacity: 1;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;
